import React from 'react';
import './styles.scss';
import useOverview from './hooks';
import RenderSalesOverview from './RenderSalesOverview';
import RenderRoutesOverview from './RenderRoutesOverview';
import RenderTableServiceTickets from './RenderTableServiceTickets';
import RenderTableRouteSchedule from './RenderTableRouteSchedule';
import RenderIntroHeader from './RenderIntroHeader';
import LandingHeader from '../../../components/layout/header/landing';

function Overview() {
  const {
    serviceTickets, serviceTicketsLoad,
    scheduleLoad, scheduleList, totalSales, overviewSales, totalSalesLoad, currentView, setCurrentView,
    routeSales, currentViewRoute, setCurrentViewRoute, routeSalesLoad, amountRoute, fullName,
    loadingClientList, clientList, vmList, vmListLoading, overviewSalesLoad,
  } = useOverview();
  return (
    <div className="py-4">
      <LandingHeader title="Overview" />
      <div className="px-4 px-xl-5">
        {/* <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '35px' }}> */}
        {/*  <h4 className="fw-bold mt-2">Overview</h4> */}
        {/*  <div className="d-flex align-items-center"> */}
        {/*    <div style={{ width: '250px', marginRight: '20px' }}> */}
        {/*      <Forms.DateRangePicker */}
        {/*        id="dateRangePicker" */}
        {/*        handleChangeStart={handleChangeStartDate} */}
        {/*        handleChangeEnd={handleChangeEndDate} */}
        {/*        startDate={{ current: new Date(selectedDate.start), max: new Date(selectedDate.end) }} */}
        {/*        endDate={{ current: new Date(selectedDate.end), max: new Date(), min: new Date(selectedDate.start) }} */}
        {/*      /> */}
        {/*    </div> */}
        {/*    <Button.CircleIcon id="userCircleIcon" icon={<User width={23} />} type="button" /> */}
        {/*  </div> */}
        {/* </div> */}
        <div className={vmList && clientList && !loadingClientList && !vmListLoading ? 'd-none' : ''}>
          <RenderIntroHeader
            fullName={fullName ?? 'Guest'}
            clientList={clientList}
            clientListLoad={loadingClientList}
            vmList={vmList}
            vmListLoad={vmListLoading}
          />
        </div>
        <RenderSalesOverview
          totalSales={totalSales}
          totalSalesLoad={totalSalesLoad || overviewSalesLoad}
          overviewSales={overviewSales}
          currentView={currentView}
          setCurrentView={setCurrentView}
        />
        <RenderRoutesOverview
          routeSales={routeSales}
          isLoading={routeSalesLoad}
          setCurrentView={setCurrentViewRoute}
          currentView={currentViewRoute}
          amount={[amountRoute]}
        />
        <div className="d-lg-flex">
          <RenderTableServiceTickets
            serviceTickets={serviceTickets}
            isLoading={serviceTicketsLoad}
          />
          <RenderTableRouteSchedule
            scheduleList={scheduleList}
            isLoading={scheduleLoad}
          />
        </div>
      </div>
    </div>
  );
}

export default Overview;
